import type React from 'react';

import { CaretDownIcon, QuestionIcon } from '@phosphor-icons/react';
import Tooltip from '@components/Presentation/atoms/Tooltip';

import { useSelectedSlide } from '@components/Presentation/hooks/useSelectedSlide';
import { Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from '@atoms/new/dropdown';
import Button from '@atoms/new/button';
import { fontList } from '@atoms/fontList';
import useFonts from '@lib/hooks/useFonts';

interface RoSFontFamilyProps {
  children: React.ReactNode;
  tooltip?: string;
}
function RoSTextFont({ children, tooltip }: RoSFontFamilyProps) {
  const selectedSlide = useSelectedSlide();
  const fonts = fontList;

  const { getFontStyle } = useFonts();

  return (
    <div className='flex items-center justify-between'>
      <h4 className={'text-sm flex gap-2 items-center '}>
        {children}
        {tooltip && (
          <Tooltip content={tooltip}>
            <QuestionIcon size={20} className='!text-default-400' />
          </Tooltip>
        )}
      </h4>

      <Dropdown
        placement='bottom-start'
      >
        <DropdownTrigger>
          <Button
            kind='tertiary'
            size='sm'
            className='w-[140px] '
            endContent={<CaretDownIcon size={16} />}
          >
            <p className='w-full text-start font-normal'
              style={{ ...getFontStyle(selectedSlide?.setting?.FontStyle as any), fontSize: '90%' }}>
              {selectedSlide?.setting?.FontStyle}</p>
          </Button>
        </DropdownTrigger>
        <DropdownMenu className='max-h-[40vh] overflow-scroll'
          disallowEmptySelection
          selectedKeys={[selectedSlide.setting.FontStyle || 'Sans-Serif']}
          selectionMode="single"
          variant="flat"
        >
          {fonts.map((option) => (
            <DropdownItem
              key={option}
              value={option}
              onClick={() =>
                selectedSlide.handler.updateSetting('FontStyle', option)
              }
              style={{ ...getFontStyle(option) }}
            >
              {option}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}

export default RoSTextFont;
